module.exports = __webpack_public_path__ + "img/s4.dfe6cea6.png";